const words = [
  "Compreender",
  "Acolher",
  "Cuidar",
  "Incluir",
  "Respeitar",
  "Comunicar",
  "Informar",
  "Apoiar",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {words.map((w) => (
      <span key={w} className="flex items-center">
        <span className="px-8 font-display text-xl italic text-brand md:text-2xl">{w}</span>
        <span className="h-1.5 w-1.5 rounded-full bg-brand/40" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-brand/10 bg-brandlight py-5"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
